import AxiosConfig from '@/config/axios-config'

export default {

  limparRespostaQuestao (ementaId) {
    return AxiosConfig.secureJalekoAPI().put(`/resposta-questao/${ementaId}`, {}).then(response => response.data)
  },

  atualizarRespostaQuestao (ementaId, idResposta) {
    return AxiosConfig.secureJalekoAPI().post(`/resposta-questao/${ementaId}`, { resposta: idResposta }).then(response => response.data)
  }

}
